import React from 'react';
import PropTypes from 'prop-types';

import CancelIcon from 'material-ui/svg-icons/navigation/cancel';
import SchoolIcon from 'material-ui/svg-icons/social/school';
import SkillIcon from 'material-ui/svg-icons/social/public';
import LibraryIcon from 'material-ui/svg-icons/av/library-books';
import ActivityIcon from 'material-ui/svg-icons/action/timeline';
import ModuleIcon from 'material-ui/svg-icons/action/view-module';

import UserComplianceContainer from '../User/UserComplianceList';

const menuItems = [
    {
        link: '/dashboard/mytraining',
        icon: <SchoolIcon />,
        label: 'My training',
    },
    {
        link: '/dashboard/mytraining/skills',
        icon: <SkillIcon />,
        label: 'My skills',
    },
    {
        link: '/dashboard/mytraining/courses',
        icon: <SchoolIcon />,
        label: 'My courses',
    },
    {
        link: '/dashboard/mytraining/modules',
        icon: <ModuleIcon />,
        label: 'My modules',
    },
    {
        link: '/dashboard/mytraining/resources',
        icon: <LibraryIcon />,
        label: 'My resources',
    },
    {
        link: '/dashboard/mytraining/activities',
        icon: <ActivityIcon />,
        label: 'My Activities',
    },
    {
        type:'divider'
    },
    {
        link: '/logout',
        icon: <CancelIcon />,
        label: 'Sign out',
    },
];

const MyCompliance = (props, {auth}) => ( <UserComplianceContainer userId={auth.identity.id} menuItems={menuItems}/> );

MyCompliance.contextTypes = {
    auth: PropTypes.shape({
        identity: PropTypes.shape({
            id: PropTypes.number.isRequired
        })
    }).isRequired
};

export default MyCompliance;
